import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component - Manages meta tags, Open Graph, Twitter Cards, and structured data
 * for individual pages. Each page MUST pass its own title, description and canonicalUrl.
 */
const SEO = ({ 
  title, 
  description, 
  canonicalUrl,
  ogImage,
  ogType = 'website',
  schemaData,
  noindex = false
}) => {
  const siteUrl = 'https://www.clinicalminds.net';
  const defaultImage = siteUrl + '/og-image.jpg';
  
  const metaTitle = title || 'Autism, ADHD & Learning Assessments Coffs Harbour | Clinical Minds Psychology';
  const metaDescription = description || 'Neurodevelopmental assessment and psychology in Coffs Harbour and via Telehealth. Lachlan Beaton, Clinical Psychologist (Registrar). Autism, ADHD, FASD and learning assessments. Medicare rebates available.';
  const metaImage = ogImage || defaultImage;
  const canonical = canonicalUrl || siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      )}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_AU" />
      <meta property="og:site_name" content="Clinical Minds Psychology" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      
      {/* Structured Data */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
